import { useContext } from 'react';
import PDPStickyButtonsContext from './PDPStickyButtonsContext';
const usePdpShowStickyButtons = () => {
  return useContext(PDPStickyButtonsContext)?.showStickyButtons ?? false;
};
export default usePdpShowStickyButtons;